export var Constants;
(function (Constants) {
    // TODO: This is hardcoded, because I cant dynamically get the current version from runeapps because of CORS.
    Constants.map_version = 1710516666;
    Constants.icons = {
        types: {
            "anagram": "/assets/icons/activeclue.png",
            "compass": "/assets/icons/arrow.png",
            "coordinates": "/assets/icons/sextant.png",
            "cryptic": "/assets/icons/activeclue.png",
            "emote": "/assets/icons/emotes.png",
            "map": "/assets/icons/map.png",
            "scan": "/assets/icons/scan.png",
            "simple": "/assets/icons/activeclue.png",
            "skilling": "/assets/icons/activeclue.png"
        }
    };
    Constants.colors = {
        dig_spot_number: "gold",
        scan_area: "#00FF21",
    };
})(Constants || (Constants = {}));
